import type { ElevationScale } from '@/theme/types'

// Совместимо с MUI shadows: index = elevation level
export const elevation: ElevationScale = [
  'none',
  '0px 1px 2px rgba(15, 23, 42, 0.08)',
  '0px 1px 3px rgba(15, 23, 42, 0.1), 0px 1px 2px rgba(15, 23, 42, 0.06)',
  '0px 4px 6px rgba(15, 23, 42, 0.1), 0px 2px 4px rgba(15, 23, 42, 0.06)',
  '0px 10px 15px rgba(15, 23, 42, 0.1), 0px 4px 6px rgba(15, 23, 42, 0.05)',
  '0px 20px 25px rgba(15, 23, 42, 0.1), 0px 10px 10px rgba(15, 23, 42, 0.04)',
  '0px 25px 50px rgba(15, 23, 42, 0.25)',
]

